export { default } from './TableBody';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/TableBody/index.js
// module id = 599
// module chunks = 121